class HHPodcastArticles extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.swiperCarousel = new Swiper(
      this.querySelector('[data-podcast-articles-carousel]'),
      {
        slidesPerView: 1.3,
        spaceBetween: 5,
        breakpoints: {
          750: {
            slidesPerView: 3,
          },
        },
      }
    )
  }
}

customElements.define('hh-podcast-articles', HHPodcastArticles)
